/* Homepage cart and predictive search. Shopify remains the source of product, price and cart state. */
(() => {
  const root = window.Shopify?.routes?.root || '/';
  const node = (tag, cls, text) => { const el = document.createElement(tag); if (cls) el.className = cls; if (text !== undefined) el.textContent = text; return el; };
  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || 'pl-PL', { style: 'currency', currency }).format(cents / 100);
  async function request(path, payload) {
    const response = await fetch(root + path, { method: payload ? 'POST' : 'GET', headers: { 'Accept': 'application/json', ...(payload && !(payload instanceof FormData) ? { 'Content-Type': 'application/json' } : {}) }, body: payload instanceof FormData ? payload : payload ? JSON.stringify(payload) : undefined, cache: 'no-store' });
    const data = await response.json();
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'Nie udało się odczytać koszyka. Spróbuj ponownie.');
    return data;
  }
  let busy = false, readVersion = 0;
  const cartDialog = () => document.getElementById('mh-cart');
  const status = text => { const el = cartDialog()?.querySelector('[data-mh-cart-status]'); if (el) el.textContent = text; };
  function renderCart(cart, source) {
    document.dispatchEvent(new CustomEvent('mh:cart-updated', { detail: { cart, source } }));
    const dialog = cartDialog(); if (!dialog) return;
    const list = dialog.querySelector('[data-mh-cart-items]'); list.replaceChildren();
    cart.items.forEach(item => {
      const row = node('article', 'mh-cart-item'); row.dataset.key = item.key; row.dataset.quantity = item.quantity;
      const imageLink = node('a'); imageLink.href = item.url;
      if (item.image) { const img = node('img'); img.src = item.image + (item.image.includes('?') ? '&' : '?') + 'width=200'; img.alt = item.product_title; imageLink.append(img); }
      const content = node('div'); const title = node('a'); title.href = item.url; title.append(node('h3', '', item.product_title)); content.append(title);
      if (item.variant_title) content.append(node('p', '', item.variant_title));
      content.append(node('strong', '', money(item.final_line_price, cart.currency)));
      const quantity = node('div', 'mh-quantity');
      for (const delta of [-1, 0, 1]) {
        if (!delta) { const count = node('span', '', item.quantity); count.dataset.mhCartQuantity = ''; quantity.append(count); }
        else { const button = node('button', '', delta > 0 ? '+' : '−'); button.type = 'button'; button.dataset.mhCartChange = delta; button.setAttribute('aria-label', (delta > 0 ? 'Zwiększ ilość: ' : 'Zmniejsz ilość: ') + item.product_title); quantity.append(button); }
      }
      const remove = node('button', 'mh-cart-remove', 'Usuń'); remove.type = 'button'; remove.dataset.mhCartRemove = ''; remove.setAttribute('aria-label', 'Usuń: ' + item.product_title);
      content.append(quantity, remove); row.append(imageLink, content); list.append(row);
    });
    dialog.querySelector('[data-mh-cart-empty]').hidden = cart.items.length > 0;
    dialog.querySelector('[data-mh-cart-summary]').hidden = !cart.items.length;
    dialog.querySelector('[data-mh-cart-total]').textContent = money(cart.total_price, cart.currency);
    document.querySelectorAll('[data-mh-cart-count]').forEach(el => el.textContent = cart.item_count);
    document.querySelectorAll('.mh-bag').forEach(el => el.setAttribute('aria-label', `Koszyk, ${cart.item_count} produktów`));
  }
  function lockCart(lock) {
    const dialog = cartDialog(); if (!dialog) return;
    dialog.setAttribute('aria-busy', String(lock));
    dialog.querySelectorAll('[data-mh-cart-change],[data-mh-cart-remove],button[name=checkout]').forEach(button => button.disabled = lock);
  }
  async function refreshCart() {
    if (busy) return; // A pending mutation owns the next authoritative read.
    const version = ++readVersion;
    status('Sprawdzamy Twój koszyk…'); lockCart(true);
    try { const cart = await request('cart.js'); if (version === readVersion) { renderCart(cart); status(''); } }
    catch (error) { if (version === readVersion) { status(error.message + ' Możesz też otworzyć pełny koszyk poniżej.'); cartDialog()?.querySelector('[data-mh-cart-summary]').setAttribute('hidden', ''); } }
    finally { if (version === readVersion) lockCart(busy); }
  }
  document.addEventListener('mh:native-cart-updated', event => {
    ++readVersion; renderCart(event.detail.cart, 'cart-items');
    status(''); lockCart(busy);
  });
  document.addEventListener('mh:dialog-open', event => { if (event.detail.dialog.id === 'mh-cart') refreshCart(); });
  document.addEventListener('click', async event => {
    const control = event.target.closest('[data-mh-cart-change],[data-mh-cart-remove]');
    if (!control || busy) return;
    const row = control.closest('.mh-cart-item'); if (!row) return;
    const restoreFocus = document.activeElement === control;
    const action = control.hasAttribute('data-mh-cart-remove') ? 'remove' : control.dataset.mhCartChange;
    const quantity = control.hasAttribute('data-mh-cart-remove') ? 0 : Math.max(0, Number(row.dataset.quantity) + Number(control.dataset.mhCartChange));
    busy = true; ++readVersion; lockCart(true); status('Aktualizujemy koszyk…');
    try {
      await request('cart/change.js', { id: row.dataset.key, quantity });
      const cart = await request('cart.js'); renderCart(cart);
      const actual = cart.items.find(item => item.key === row.dataset.key)?.quantity || 0;
      status(actual === quantity ? '' : 'Ilość została dopasowana do dostępności produktu.');
    } catch (error) { status(error.message + ' Otwórz koszyk ponownie, aby sprawdzić aktualną zawartość.'); }
    finally {
      busy = false; lockCart(false);
      if (restoreFocus && cartDialog()?.open && (document.activeElement === document.body || document.activeElement === control || !document.activeElement?.isConnected)) {
        const currentRow = [...cartDialog().querySelectorAll('.mh-cart-item')].find(item => item.dataset.key === row.dataset.key);
        const target = currentRow?.querySelector(action === 'remove' ? '[data-mh-cart-remove]' : `[data-mh-cart-change="${action}"]`) || cartDialog().querySelector('[data-mh-cart-change], [data-mh-close]');
        target?.focus({ preventScroll: true });
      }
    }
  });
  document.addEventListener('click', event => {
    const counter = event.target.closest('[data-mh-quick-quantity]');
    if (counter && !busy) {
      const quantity = counter.closest('form').querySelector('[name=quantity]');
      quantity.value = Math.max(1, (Number(quantity.value) || 1) + Number(counter.dataset.mhQuickQuantity));
      quantity.dispatchEvent(new Event('input', {bubbles:true}));
    }
    const swatch = event.target.closest('[data-mh-look-colour]');
    if (!swatch || swatch.hidden || swatch.disabled || busy) return;
    const select = swatch.closest('.mh-look-product').querySelector('[data-mh-look-variant]');
    if (!select || select.disabled) return;
    const current = select.selectedOptions[0];
    const options = [...select.options].filter(option => option.dataset.colour === swatch.dataset.mhLookColour && option.dataset.available === 'true');
    const sameSize = options.find(option => option.dataset.size === current?.dataset.size && option.dataset.option3 === current?.dataset.option3);
    const chosen = current?.value ? sameSize : options[0];
    if (!chosen) return;
    select.value = chosen.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-mh-look-variant]'); if (!select) return;
    const option = select.selectedOptions[0], product = select.closest('.mh-look-product');
    const available = option?.dataset.available === 'true';
    const title = product.querySelector('[data-mh-look-title]');
    if (title && option?.dataset.title) title.textContent = option.dataset.title;
    const price = product.querySelector('[data-mh-look-price]'); if (price) price.textContent = option?.dataset.price || '';
    window.MarbilyUI?.syncSalePrice?.(product, option?.dataset);
    product.querySelector('button[type=submit]').disabled = !available;
    product.querySelector('[data-mh-add-label]').textContent = available ? 'Dodaj do koszyka' : 'Wariant wyprzedany';
    product.querySelector('[data-mh-form-status]').textContent = '';
    product.querySelectorAll('[data-mh-look-colour]').forEach(swatch => {
      swatch.hidden = ![...select.options].some(candidate => candidate.dataset.available === 'true' && candidate.dataset.colour === swatch.dataset.mhLookColour && (!option?.value || (candidate.dataset.size === option.dataset.size && candidate.dataset.option3 === option.dataset.option3)));
      swatch.disabled = swatch.hidden;
      swatch.setAttribute('aria-pressed', String(swatch.dataset.mhLookColour === option?.dataset.colour));
    });
    const colourName = product.querySelector('[data-mh-look-colour-name]');
    if (colourName) colourName.textContent = option?.dataset.colour || '';
    const preview = product.querySelector('[data-mh-look-image]') || select.closest('.mh-quick-dialog')?.querySelector('[data-mh-quick-image]');
    if (preview) {
      preview.hidden = !option?.dataset.image;
      if (option?.dataset.image) preview.src = option.dataset.image; else preview.removeAttribute('src');
      preview.alt = option?.textContent.trim() || '';
      const missing = preview.parentElement.querySelector('[data-mh-missing-photo]');
      if (missing) missing.hidden = Boolean(option?.dataset.image);
    }
    if (option?.dataset.url) product.querySelectorAll('[data-mh-variant-link]').forEach(link => link.href = option.dataset.url);
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-mh-add-cart], body.mh-product-page product-form form'); if (!form) return;
    const nativeProduct = Boolean(form.closest('product-form'));
    if (nativeProduct) event.stopImmediatePropagation();
    event.preventDefault(); if (busy || form.querySelector('button[type=submit]')?.disabled) return;
    const id = Number(new FormData(form).get('id')); const quantity = Number(new FormData(form).get('quantity')) || 1;
    let message = form.querySelector('[data-mh-form-status]');
    if (!message) { message = node('p', 'mh-form-status'); message.dataset.mhFormStatus = ''; message.setAttribute('role', 'status'); form.append(message); }
    const nativePayload = nativeProduct ? new FormData(form) : null;
    const button = form.querySelector('button[type=submit]');
    const variantSelect = form.querySelector('[data-mh-look-variant]');
    if (variantSelect) variantSelect.disabled = true;
    busy = true; ++readVersion; button.disabled = true; form.setAttribute('aria-busy', 'true'); message.textContent = 'Dodajemy do koszyka…';
    try {
      await request('cart/add.js', nativePayload || { items: [{ id, quantity }] });
      const cart = await request('cart.js');
      if (!cart.items.some(item => item.variant_id === id && item.quantity >= quantity)) throw new Error('Nie potwierdziliśmy dodania produktu. Sprawdź koszyk przed ponowną próbą.');
      renderCart(cart); status(''); message.textContent = '';
      window.MarbilyUI.openDialog(cartDialog(), document.querySelector('.mh-bag'));
    } catch (error) { message.textContent = error.message + ' Sprawdź koszyk przed ponownym dodaniem.'; }
    finally { busy = false; form.removeAttribute('aria-busy'); if (variantSelect) variantSelect.disabled = false; if (variantSelect) button.disabled = variantSelect.selectedOptions[0]?.dataset.available !== 'true';
      else if (form.hasAttribute('data-mh-card-add')) button.disabled = form.dataset.available !== 'true';
      else if (!nativeProduct || Number(new FormData(form).get('id')) === id) button.disabled = false;
      lockCart(false); }
  }, true); // Capture native PDP submit so one drawer owns cart mutations.
  let searchTimer, searchAbort, searchVersion = 0;
  document.addEventListener('mh:search-close', () => { ++searchVersion; clearTimeout(searchTimer); searchAbort?.abort(); });
  document.addEventListener('input', event => {
    if (event.target.id !== 'mh-search-input') return;
    const input = event.target, results = input.closest('[data-mh-search-panel]').querySelector('[data-mh-search-results]');
    const query = input.value.trim(), version = ++searchVersion;
    clearTimeout(searchTimer); searchAbort?.abort(); results.replaceChildren();
    if (query.length < 2) return;
    searchTimer = setTimeout(async () => {
      searchAbort = new AbortController(); results.textContent = 'Szukamy…';
      try {
        const params = new URLSearchParams({ q: query, 'resources[type]': 'product', 'resources[limit]': '10', 'resources[options][unavailable_products]': 'hide', section_id: 'mh-predictive-products' });
        const response = await fetch(root + 'search/suggest?' + params, { signal: searchAbort.signal });
        if (!response.ok) throw new Error('search');
        const html = await response.text(); if (version !== searchVersion || !results.isConnected) return;
        const rendered = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-mh-predictive-products]');
        if (!rendered) throw new Error('search');
        results.replaceChildren();
        const products = [...rendered.querySelectorAll('.mh-search-result')];
        products.forEach(link => results.append(link));
        if (!products.length) results.textContent = 'Nie znaleźliśmy podpowiedzi. Spróbuj innej nazwy lub zobacz pełne wyniki.';
        const all = node('a', 'mh-text-link', 'Zobacz wszystkie wyniki →'); all.href = root + 'search?type=product&filter.v.availability=1&q=' + encodeURIComponent(query); results.append(all);
      } catch (error) {
        if (error.name !== 'AbortError' && version === searchVersion && results.isConnected) results.textContent = 'Naciśnij Enter, aby wyszukać produkty.';
      }
    }, 200);
  });
})();
